var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { TravelBuddyConversationsModalData } from './travel.buddy.conversations.modal.provider';
import { SchedulerApiService } from '../../../../services/scheduler.api.service';
var TravelBuddyConversationsModalComponent = /** @class */ (function (_super) {
    __extends(TravelBuddyConversationsModalComponent, _super);
    function TravelBuddyConversationsModalComponent(fb, apiService, alertify, formBuilder, modalService, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.apiService = apiService;
        _this.alertify = alertify;
        _this.formBuilder = formBuilder;
        _this.modalService = modalService;
        _this.dialogRef = dialogRef;
        _this.loadingAccounts = false;
        _this.loadingUsers = false;
        _this.accountNames = [];
        _this.users = [];
        _this.accountName = '';
        _this.userName = '';
        _this.conversations = [];
        _this.account = Object.assign({}, data);
        return _this;
    }
    TravelBuddyConversationsModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this.formBuilder.group({
            assistantId: [null, null],
        });
        this.loadingAccounts = true;
        this.apiService
            .getTravelBuddyConversationClientAggregation()
            .finally(function () { return (_this.loadingAccounts = false); })
            .subscribe(function (data) {
            _this.accountNames = data.map(function (x) { return x._id; });
            console.log(_this.accountNames);
        });
    };
    TravelBuddyConversationsModalComponent.prototype.setAccount = function (account) {
        var _this = this;
        this.accountName = account;
        this.conversations = [];
        this.users = [];
        this.userName = '';
        this.apiService.getTravelBuddyConversationUserAggregation(this.accountName).subscribe(function (data) {
            _this.users = data.map(function (x) { return x._id; }); // hatfield.randy@gmail.com|google
        });
    };
    TravelBuddyConversationsModalComponent.prototype.setUser = function (userId) {
        var _this = this;
        this.userName = this.processUser(userId);
        this.conversations = [];
        this.apiService.getTravelBuddyConversationByUser(this.accountName, userId).subscribe(function (data) {
            console.log(data);
            _this.conversations = data.filter(function (x) { return !!x.conversation; }); // filter out those client not allowed to track conversation
        });
    };
    TravelBuddyConversationsModalComponent.prototype.processUser = function (userId) {
        return userId.split('|')[0];
    };
    TravelBuddyConversationsModalComponent.prototype.getConversationTitle = function (conversation) {
        return new Date(conversation.createdAt).toLocaleString() + " (" + conversation.timeConsumed.toFixed(1) + "s)";
    };
    TravelBuddyConversationsModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    TravelBuddyConversationsModalComponent.prototype.confirm = function (event) { };
    return TravelBuddyConversationsModalComponent;
}(BaseComponent));
export { TravelBuddyConversationsModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/travel.buddy.conversations/travel.buddy.conversations.modal.component.ts.pre-build-optimizer.js